import {gql} from '@apollo/client';
import {
    ComplaintListPage,
    CustomerComplaintHqListFilter,
    CustomerComplaintListFilter,
    PageRequestTypeInput,
} from '../types/CustomerComplaintType';

export const CUSTOMER_COMPLAINT_LIST_FIELDS = `
    id
    complaintCategory
    complaintType
    source
    externalRefId
    externalRefCode
    driverId
    dspId
    orderId
    hubId
    warehouseId
    status
    isFinished
    appealDeadlineAt
    finishedAt
    createdAt
    updatedAt
    appealSubmittedAt
    trackingNumber
    warehouseName
    dspName
    thirdSortingCode
    driverName
    orderOverallStatus
    recipientAddress
`;

export const GET_CUSTOMER_COMPLAINT_PAGE_LIST = gql`
    query GetCustomerComplaintPageListByFilters(
        $filter: CustomerComplaintListFilterInput,
        $pageRequest: PageRequestTypeInput
    ) {
        getCustomerComplaintPageListByFilters(filter: $filter, pageRequest: $pageRequest) {
            content {
                ${CUSTOMER_COMPLAINT_LIST_FIELDS}
            }
            totalElements
            page
            size
        }
    }
`;

export interface GetCustomerComplaintPageListResponse {
    getCustomerComplaintPageListByFilters: ComplaintListPage;
}

export interface GetCustomerComplaintPageListVariables {
    filter?: CustomerComplaintListFilter;
    pageRequest?: PageRequestTypeInput;
}

// WMS 视角专用：资源码 + 仓库越权双重鉴权；filter.warehouseId 必填
export const GET_CUSTOMER_COMPLAINT_PAGE_LIST_FOR_WMS = gql`
    query GetCustomerComplaintPageListForWms(
        $filter: CustomerComplaintListFilterInput!,
        $pageRequest: PageRequestTypeInput
    ) {
        getCustomerComplaintPageListForWms(filter: $filter, pageRequest: $pageRequest) {
            content {
                ${CUSTOMER_COMPLAINT_LIST_FIELDS}
            }
            totalElements
            page
            size
        }
    }
`;

export interface GetCustomerComplaintPageListForWmsResponse {
    getCustomerComplaintPageListForWms: ComplaintListPage;
}

// QC 总部（HQ）视角专用：纯资源码鉴权（CS_DSP_APPEAL_SUMMARY），filter 不含 warehouseId（全美），时间范围必填
export const GET_CUSTOMER_COMPLAINT_PAGE_LIST_FOR_HQ = gql`
    query GetCustomerComplaintPageListForHq(
        $filter: CustomerComplaintHqListFilterInput!,
        $pageRequest: PageRequestTypeInput
    ) {
        getCustomerComplaintPageListForHq(filter: $filter, pageRequest: $pageRequest) {
            content {
                ${CUSTOMER_COMPLAINT_LIST_FIELDS}
            }
            totalElements
            page
            size
        }
    }
`;

export interface GetCustomerComplaintPageListForHqResponse {
    getCustomerComplaintPageListForHq: ComplaintListPage;
}

export interface GetCustomerComplaintPageListForHqVariables {
    filter: CustomerComplaintHqListFilter;
    pageRequest?: PageRequestTypeInput;
}
